export default __webpack_public_path__ + "static/media/help-guide-icon.4e9eafe0.svg";